export default __webpack_public_path__ + "static/media/report-manager-not-selected_skyblue.0a0ec137.svg";